import React from 'react';

export default function ReportWear({ wearAndTear }) {
  const description = ["", "PASS", "FAIL"]
  const fontColor = ["white", "green", "red"]
  return(
    <div className="report-section">
      <h2>Wear and Tear Assessment</h2>
      <table>
        <tbody>
          <tr>
            <th>Item</th>
            <th>Status</th>
          </tr>
          <tr>
            <td>Brake Pads (>3mm)</td>
            <td style={{fontWeight:"bold", color:fontColor[wearAndTear.brakePads]}}>{description[wearAndTear.brakePads]}</td>
          </tr>
          <tr>
            <td>Tyre Threads Depth (>3mm)</td>
            <td style={{fontWeight:"bold", color:fontColor[wearAndTear.tyreThreads]}}>{description[wearAndTear.tyreThreads]}</td>
          </tr>
          <tr>
            <td>Undercarriage Noise</td>
            <td style={{fontWeight:"bold", color:fontColor[wearAndTear.undercarriage]}}>{description[wearAndTear.undercarriage]}</td>
          </tr>
          <tr>
            <td>Engine Mounting</td>
            <td style={{fontWeight:"bold", color:fontColor[wearAndTear.engineMounting]}}>{description[wearAndTear.engineMounting]}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

